<p-dialog
  header="Modifica Produttore"
  [(visible)]="isVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="onDialogHide()"
  [style]="{ width: '25rem' }"
>
  <div class="commission-form">
    <div *ngIf="isLoading" class="spinner-overlay">
      <div class="spinner-container">
        <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
      </div>
    </div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <label for="producerCode">Codice Produttore</label>
      <input
        pInputText
        id="producerCode"
        type="number"
        formControlName="producerCode"
        placeholder="Inserisci"
        min="0"
        max="999"
        class="commission-input my-2"
        (keydown)="blockInvalidInput($event)"
        (paste)="blockInvalidInput($event)"
      />

      <div class="d-flex justify-content-center">
        <button class="btn btn-primary button mx-3 my-2" type="submit">
          MODIFICA
        </button>
      </div>
    </form>
  </div>
</p-dialog>
